export const LicensePlateTypeCodes = [
  {
    value: 'AM',
    label: 'Ambulance',
  },
  {
    value: 'AP',
    label: 'Apportioned',
  },
  {
    value: 'AQ',
    label: 'Antique',
  },
  {
    value: 'AR',
    label: "Amateur Radio or Citizen's Ban",
  },
  {
    value: 'AT',
    label: 'All-Terrain Veh',
  },
  {
    value: 'BU',
    label: 'Bus',
  },
  {
    value: 'CC',
    label: 'Consular Corps',
  },
  {
    value: 'CI',
    label: 'City-Owned or Municipal Veh',
  },
  {
    value: 'CL',
    label: 'Collegiate or University',
  },
  {
    value: 'CO',
    label: 'Commercial',
  },
  {
    value: 'CU',
    label: 'County-Owned Veh',
  },
  {
    value: 'DA',
    label: 'Drive-Away',
  },
  {
    value: 'DB',
    label: 'Dune Buggy',
  },
  {
    value: 'DD',
    label: 'Dentist',
  },
  {
    value: 'DL',
    label: 'Dealer',
  },
  {
    value: 'DP',
    label: 'Diplomatic',
  },
  {
    value: 'DU',
    label: 'Duplicate, Reissue, or Replace',
  },
  {
    value: 'DV',
    label: 'Disabled Veteran',
  },
  {
    value: 'DX',
    label: 'Disabled or Handicapped Person',
  },
  {
    value: 'EX',
    label: 'Exempt',
  },
  {
    value: 'FD',
    label: 'Fire Department',
  },
  {
    value: 'FG',
    label: 'Foreign Government',
  },
  {
    value: 'FM',
    label: 'Farm Veh',
  },
  {
    value: 'IP',
    label: 'International Plate',
  },
  {
    value: 'IT',
    label: 'In-Transit Veh',
  },
  {
    value: 'JJ',
    label: 'Judge or Justice',
  },
  {
    value: 'LE',
    label: 'Legislative, U.S.',
  },
  {
    value: 'LF',
    label: 'Law Enforcement',
  },
  {
    value: 'LS',
    label: 'Legislative, State',
  },
  {
    value: 'MC',
    label: 'Motorcycle',
  },
  {
    value: 'MD',
    label: 'Motorcycle Dealer',
  },
  {
    value: 'MF',
    label: 'Manufacturer',
  },
  {
    value: 'ML',
    label: 'Military Veh, Canadian',
  },
  {
    value: 'MP',
    label: 'Moped',
  },
  {
    value: 'MV',
    label: 'Military Veh, U.S.',
  },
  {
    value: 'MY',
    label: 'Aircraft, Military',
  },
  {
    value: 'NG',
    label: 'National Guard Member',
  },
  {
    value: 'NP',
    label: 'Aircraft, Civilian, Nonpassngr',
  },
  {
    value: 'OB',
    label: 'Omnibus',
  },
  {
    value: 'PC',
    label: 'Regular Passenger Automobile',
  },
  {
    value: 'PE',
    label: 'Personalized or Customized',
  },
  {
    value: 'PH',
    label: 'Physician',
  },
  {
    value: 'PP',
    label: 'Aircraft, Civilian, Passenger',
  },
  {
    value: 'PX',
    label: 'Pharmacist',
  },
  {
    value: 'RE',
    label: 'Reciprocal or Reciprocity',
  },
  {
    value: 'RV',
    label: 'Rented Veh or Trailer',
  },
  {
    value: 'SC',
    label: 'Special-Purpose Commercial Veh',
  },
  {
    value: 'SN',
    label: 'Snowmobile',
  },
  {
    value: 'ST',
    label: 'State-Owned Veh',
  },
  {
    value: 'SV',
    label: 'School Veh',
  },
  {
    value: 'TK',
    label: 'Truck',
  },
  {
    value: 'TL',
    label: 'Trailer',
  },
  {
    value: 'TM',
    label: 'Temporary',
  },
  {
    value: 'TP',
    label: 'Transporter',
  },
  {
    value: 'TR',
    label: 'Truck-Tractor',
  },
  {
    value: 'TX',
    label: 'Taxi',
  },
  {
    value: 'US',
    label: 'U.S. Government Veh',
  },
  {
    value: 'VF',
    label: 'Veteran of Foreign Wars',
  },
  {
    value: 'ZZ',
    label: 'All Others',
  },
];
